/* eslint-disable */
// src/layouts/visitMachine/strategies/strategySelector.js

import { TragamonedaStrategy } from "./TragamonedaStrategy";
import { FichaStrategy } from "./FichaStrategy";
import { CashStrategy } from "./CashStrategy";
import { PrizeStrategy } from "./PrizeStrategy";
import { RentStrategy } from "./RentStrategy";
import { hasRent } from "utils/rent";

/* File: src/layouts/visitMachine/strategies/strategySelector.js
 * Devuelve la estrategia de cálculo según el tipo de máquina.
 * Cada estrategia implementa calculate(machine, inputs, prev, %, modo, prevRecords).
 * Encapsula reglas por tipo (p.ej., acumulativas vs. no acumulativas).
 */

/**
 * Dado un objeto LocalMachine, devuelve la estrategia adecuada de recaudación.
 * Si tiene una renta asociada, se aplica la estrategia de renta sin importar el tipo de máquina.
 * Si no tiene renta, se elige la estrategia según el tipo de máquina y otras propiedades.
 */
export function getCollectionStrategy(localMachine) {
  // Si tiene renta asociada, se aplica RentStrategy
  if (hasRent(localMachine)) {
    return new RentStrategy();
  }

  const type =
    localMachine?.MachineType?.Type ??
    (typeof localMachine?.MachineType === "string" ? localMachine.MachineType : null) ??
    localMachine?.MachineTypeType ??
    null;
  const isAccumulative = localMachine?.IsAccumulative;

  switch (type) {
    case "Pool":
    case "Tejo":
      return new FichaStrategy();

    case "Peluchera":
      return new PrizeStrategy();

    case "Rockola":
      return new CashStrategy();

    case "Tragamoneda":
      return new TragamonedaStrategy(isAccumulative); // isAccumulative modifica la estrategia internamente

    default:
      console.warn(`No se encontró estrategia para el tipo de máquina: ${type}`);
      return null;
  }
}
